import {SxProps, Theme} from '@mui/material';
import {pillShapePhoneSx} from 'src/components/common/pillFit.sx';
import theme from 'src/theme';

/**
 * What the session took, as a pill.
 *
 * Energy is the one number somebody scanning a charger's sessions is after, so it is read at a
 * glance rather than found among the rows.
 */
/** A fact whose value opens a record: the colour the link had in the row this card replaced. */
export const factLinkSx: SxProps<Theme> = {
    color: theme.palette.primary.main,
    fontSize: 'inherit',
    fontWeight: 'inherit',
};

export const energyPillSx: SxProps<Theme> = {
    ...pillShapePhoneSx,
    display: 'inline-flex',
    alignItems: 'center',
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.primaryColor.A50,
    border: `1px solid ${theme.palette.primaryColor.A100}`,
};
